// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"1d90172d","453":"c56bdfaa"}[chunkId] + ".chunk.js";
};